import { QRButtonDefault, } from "./QRButtonDefault.tsx";
import { QRButtonModerator, } from "./QRButtonModerator.tsx";
import { useModeratorStore, } from "../../../../store/moderatorStore.ts";

export function QRButton() {
  const isModerator = useModeratorStore(state => state.isModerator,);

  return (
    <>
      {isModerator ? <QRButtonModerator /> : <QRButtonDefault />}
    </>
  );
}
